import TempWFRuleWrapper from "./TempWFRuleWrapper";

export default TempWFRuleWrapper;
